import React from "react";
import { BrowserRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Route, Routes } from "react-router-dom";

import Issues from "../screens/issues";
import Snags from "../screens/snags";
import Hitches from "../screens/hitches";
import IssueDetails from "../screens/Issue-details";
import CreateHitch from "../screens/create-hitch/screen";
import CreateSnag from "../screens/create-snag/screen";

const MainRouter = ({ userToken }) => {

  return (
    <BrowserRouter>
      {true ? (
        <Routes>
            <Route
                path="/"
                element={<Issues />}
            />
            <Route
                path="/create-hitch"
                element={<CreateHitch />}
            />
            <Route
                path="/create-snag"
                element={<CreateSnag />}
            />
            <Route
                path="/issues"
                element={<Issues/>}
            />
            <Route
                path="/snags"
                element={<Snags/>}
            />
            <Route
                path="/hitches"
                element={<Hitches/>}
            />
            <Route
                path="/issue-details"
                element={<IssueDetails/>}
            />
        </Routes>
      ) : (
        <Routes>
            <Route
                path={'/404'}
                render={() => (<div>Route Not Found!</div>)}
            />
        </Routes>
        )}
    </BrowserRouter>
  );
};

const mapStateToProps = state => {
  return {
    userToken: state.common.userToken,
  };
};

const mapDispatchToProps = state => {
  return {};
};

export const RootRouter = connect(
  mapStateToProps,
  mapDispatchToProps
)(MainRouter);
